module.exports = __webpack_public_path__ + "media/images/front/icons/like_off-a8ab8019096c31473ca81301212d2f84.png";